import { HTMLAttributes, memo } from 'react';
import { Scrollbars as CustomScrolls } from 'react-custom-scrollbars';

import clsx from 'clsx';

import { useStyles } from './Scrollbars.styles';
import { ScrollbarsProps } from './Scrollbars.types';

export type { CustomScrolls };

export const Scrollbars = memo(({ key, offset, children, getInstance, ...props }: ScrollbarsProps) => {
  const styles = useStyles({ offset });

  return (
    <CustomScrolls
      key={key}
      autoHideTimeout={800}
      autoHideDuration={200}
      renderTrackHorizontal={(props: HTMLAttributes<HTMLDivElement>) => (
        <div {...props} className={styles.trackHorizontal} />
      )}
      renderTrackVertical={(props: HTMLAttributes<HTMLDivElement>) => (
        <div {...props} className={styles.trackVertical} />
      )}
      renderThumbHorizontal={(props: HTMLAttributes<HTMLDivElement>) => (
        <div {...props} className={styles.thumbHorizontal} />
      )}
      renderThumbVertical={(props: HTMLAttributes<HTMLDivElement>) => (
        <div {...props} className={styles.thumbVertical} />
      )}
      {...props}
      ref={getInstance}
      className={clsx(styles.scrollbars, props.className)}
    >
      {typeof offset?.width === 'number' || typeof offset?.height === 'number' ? (
        <div className={styles.content}>{children}</div>
      ) : (
        children
      )}
    </CustomScrolls>
  );
});
